import endpoints from 'api/endpoints';
import { api } from 'api/rest';

export class TournamentTemplateService {
  static async findAll() {
    const response = await api.get(endpoints.tournamentTemplates);
    return response;
  }

  static async create(data: Record<string, any>) {
    const response = await api.post(endpoints.tournamentTemplates, data);
    return response;
  }

  static async getByID(id: string) {
    const response = await api.get(`${endpoints.tournamentTemplates}/${id}`);
    return response;
  }

  static async updateByID(id: string, data: Record<string, any>) {
    const response = await api.put(`${endpoints.tournamentTemplates}/${id}`, data);
    return response;
  }

  static async deleteByID(id: string) {
    const response = await api.delete(`${endpoints.tournamentTemplates}/${id}`);
    return response;
  }
}
